import * as React from "react";
import "@frameworks/shared-library/stylesheets/components/error_msg.scss";
var Errormsg = function (props) {
    var _a, _b;
    var _c = props.showIcon, showIcon = _c === void 0 ? true : _c;
    var getErrorMessage = function (message) {
        if (typeof message === "string") {
            return React.createElement("span", { dangerouslySetInnerHTML: { __html: message } });
        }
        return message;
    };
    return (React.createElement("div", { className: "error-msg flexCenter ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") },
        React.createElement("div", { className: "error-msg-wrapper" },
            showIcon ? (React.createElement("div", null, props.image ? (React.createElement("img", { src: props.image })) : (React.createElement("span", { className: "erroricon  ".concat(props.icon ? props.icon : "edel-icon-error-msg-icon") })))) : (React.createElement(React.Fragment, null)),
            React.createElement("div", { className: "error-msg-text ".concat((_b = props === null || props === void 0 ? void 0 : props.parentErrorClassName) !== null && _b !== void 0 ? _b : "") }, props.msg
                ? getErrorMessage(props.msg)
                : "We ran in to some technical difficulties  please click refresh and try again"),
            props.customComp ? (React.createElement("div", null, props.customComp)) : (props.refresh === true && (React.createElement("div", { className: "refreshErrorBtn" },
                React.createElement("button", { className: "btn d-flex align-items-center", onClick: function () { return props.refreshFunc(); } },
                    React.createElement("div", { className: "refreshErrorBtn-icon" },
                        React.createElement("i", { className: "d-flex edel-icon-double-refresh" })),
                    React.createElement("p", null, "Refresh"))))))));
};
export default Errormsg;
